<template>
  <div>
    <el-row>
      <div class="news_title">{{ newsContent.title }}</div>
      <div style="text-align: center;">
        <el-tag class="margin-left" effect="dark" type="info" size="mini">
          <i class="el-icon-date"></i>
          时间：{{ newsContent.create_date }}
        </el-tag>
        <el-tag class="margin-left" effect="dark" type="success" size="mini">
          <i class="el-icon-view"></i>
          阅读：{{ newsContent.reads }}
        </el-tag>
        <el-tag class="margin-left" effect="dark" type="warning" size="mini">
          <i class="el-icon-thumb"></i>
          点赞：{{ newsContent.thumbup }}
        </el-tag>
      </div>
    </el-row>

    <el-divider></el-divider>
    <el-row :gutter="25">
      <el-col :xs="24" :sm="8"><img :src="$domainPrefix + newsContent.thumb" alt="" class="news_thumb" /></el-col>
      <el-col :xs="24" :sm="16">
        <el-page-header @back="goBack" content="阅读详情"></el-page-header>
        <div class="news-content" v-html="newsContent.content"></div>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="margin: 40px 0; text-align: center;">
        <el-button type="danger" @click="thumbUp">
          <i class="el-icon-thumb"></i>
          点赞 ( {{ thumbs }} )
        </el-button>
      </el-col>
      <el-col>
        <div><el-alert center title="本网站涉及著作权项目,禁止任何形式的复制和重新编辑!" type="info" :closable="false"></el-alert></div>
      </el-col>
      <el-col style="margin-top: 20px; text-align: center;"><vshare :key="$route.fullPath" :vshareConfig="vshareConfig"></vshare></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
    data () {
        return {
            newsContent: {},
            thumbs: '',
            vshareConfig: {
                shareList: [
                    // 此处放分享列表（ID）
                ],
                common: {
                    // 此处放置通用设置
                },
                share: [
                    {
                        // 此处放置分享按钮设置
                    }
                ],
                slide: [{ bdImg: 4, bdPos: 'right', bdTop: 200 }],
                image: [
                    // 此处放置图片分享设置
                ],
                selectShare: [
                    // 此处放置划词分享设置
                ]
            }
        }
    },

    created: function () {
        var that = this
        var id = that.$route.params.id
        this.$axios
            .get('/api/getnewscontent/', {
                params: {
                    pk: id
                }
            })
            .then(function (response) {
                that.$data.newsContent = response.data
                that.thumbs = response.data.thumbup
            })
            .catch(function (error) {
                console.log(error)
            })
    },
    methods: {
        thumbUp () {
            var that = this
            var id = that.$route.params.id
            this.$axios
                .post('/api/thumbup/', {
                    params: {
                        pk: id
                    }
                })
                .then(function (res) {
                    if (res.data.code === 'success') {
                        that.thumbs = res.data.value
                        that.$notify({
                            title: '提示',
                            message: '点赞成功',
                            type: 'success',
                            position: 'top-right'
                        })
                    } else {
                        that.$message({
                            message: '请不要重复点赞，感谢',
                            type: 'warning'
                        })
                    }
                })
        },
        goBack () {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.margin-left {
  margin-left: 10px;
}

.news_title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  padding: 20px 0px;
  text-align: center;
}

.news-content {
  margin-top: 10px;
  font-size: 15px;
}

.news-content img {
  width: 100%;
  height: auto;
}

.news_thumb {
  width: 100%;
  height: auto;
}
</style>
